import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import axios from "axios";

const ViewLeave = () => {
  const { leave_id } = useParams();
  const navigate = useNavigate();

  const [leave, setLeave] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // useEffect(() => {
  //   // Replace with real API fetch by id
  //   const fetchedLeave = {
  //     id: id || 1,
  //     customer_name: "Sample",
  //     mobile: "9952386336",
  //     address: "71, name street, pudhoor, sivakasi - 626342",
  //     type: "Leave",
  //     date: "25-07-2025",
  //     reason: "Sick Leave",
  //     adjustment: "Sample(sample@gmail.com)",
  //     attachment: null,
  //     status: "Pending",
  //     action_by: "admin",
  //   };

  //   setLeave(fetchedLeave);
  // }, [id]);

  useEffect(() => {
    axios.post(`${API_BASE_URL}leave_permission_detail.php`, { leave_id: leave_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          setLeave(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setLeave([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLeave([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  if (!leave) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View Leave Request</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  const fields = [
    { label: "Name", value: leave.name },
    { label: "Leave/Permission", value: leave.type },
    ...(leave.type === "Half Day Leave"
    ? [{
        label: "Session",
        value:
          leave.session === "AN"
            ? "Afternoon"
            : leave.session === "FN"
              ? "Forenoon"
              : "-"
      }]
    : []),

  // ✅ Leave Type logic
  ...(leave.type !== "Permission"
    ? [{
        label: "Type",
        value:
          leave.staff_type !== "Aided"
            ? "CL"
            : leave.aided_leave_type
      }]
    : []),

    { label: "Date / Duration", value: leave.leave_date },
    { label: "Reason", value: leave.reason },
    { label: "Work Adjustment", value: leave.work_adjustment_name },
    {
      label: "Attachment",
      value: leave.file_name ? (
        <a
          href={leave.file}
          download={leave.file_name} // optional
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline', color: '#0d6efd' }}
        >
          {leave.file_name}
        </a>

      ) : (
        "—"
      ),
    },

    { label: "Status", value: leave.status },
    { label: "Action By", value: leave.action_by_name },
  ];


  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View Leave Request</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          {/* Keep photo column for layout consistency; leave empty or add icon/avatar */}
          <div className="customer-photo-wrap" aria-hidden />

          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`Leave details for ${leave.name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewLeave;
